<template>
  <div class="training-batch-setting">
    <div class="header">
      <div class="title">训练通用设置</div>
    </div>
    <div class="main">
      <div class="main-cont">
        <TrainingBatchSettingMain :batch-id="batchId"/>
      </div>
    </div>
  </div>
</template>

<script>
import TrainingBatchSettingMain from './main'
export default {
  name: 'TrainingBatchSetting',
  components: { TrainingBatchSettingMain },
  props: {
    rowData: {
      type: Object,
      required: true
    }
  },
  computed: {
    batchId () {
      return this.rowData ? this.rowData.id : ''
    }
  }
}
</script>

<style lang="scss">
.training-batch-setting {
  height: 100%;
  display: flex;
  flex-direction: column;
  & > .header {
    flex: none;
    & > .title {
      font-size: 13px;
      text-align: center;
      background-color: #fff;
      padding: 15px;
      border-bottom: 1px solid #ebeef5;
    }
  }
  & > .main {
    flex: auto;
    background-color: #fff;
    position: relative;
    & > .main-cont {
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
    }
  }
}
</style>
